import React from 'react';
import {N8N} from "./index";

export default function Overview() {
	const n8n = React.useContext(N8N);
	const recentRuns = n8n.useRecentRuns();

	return <section id='overview'>
		<div id='runs'>
			<h1>Kickoff läufe</h1>
			<p>Neue Kickoff läufe</p>
			{recentRuns
				? recentRuns.map(run => <div className='card'>
					<span className={['capsule', capsuleStyle(run.updatedAt)].join(' ')}>{new Intl.DateTimeFormat('de', {
						dateStyle: 'medium'
					}).format(run.createdAt)}</span>

					<h1>{run.job}</h1>
					<code className='project-nr'>{run.project}</code>
				</div>)
				: <Skeleton />}
		</div>
	</section>;
}

function Skeleton() {
	return <div className='card skeleton'>

	</div>
}

function capsuleStyle(date: Date): string {
	const diff = (new Date().getTime() - date.getTime()) / 3_600_000;

	return diff > 7 ? 'green' : diff > 3 ? 'yellow' : diff > 1 ? 'orange' : 'red';
}